// Helper function to get environment-based title prefix
export const getTitlePrefix = () => {
  const hostname = window.location.hostname.toLowerCase();
  // Check for test first (test takes priority over dev)
  if (hostname.includes('test')) {
    return 'TEST ';
  }
  // Check for dev or development mode
  if (hostname.includes('dev') || process.env.NODE_ENV === 'development') {
    return 'DEV ';
  }
  return '';
};

// Helper function to get the full page title with environment prefix
export const getPageTitle = (baseTitle = 'Gifalot') => {
  const prefix = getTitlePrefix();
  return `${prefix}${baseTitle}`;
};
